<upgrade-page mode="pricing"></upgrade-page>